import DataService from '@shared/services/data.service';
import { getApiErrorMessage } from '../consts/RenderingConfig.consts';

/**
 * Shared staff check, engine-list cache key, and user-agent loading for rendering pages.
 */
export default {
  data() {
    return {
      userAgents: [],
    };
  },
  computed: {
    isStaff() {
      return this.$store.getters.hasFeature('cloudsine-staff');
    },
    engineCacheKey() {
      const user = (this.$store.state.user && this.$store.state.user.data) || {};
      return `${user.id || user.customer_id || 'unknown'}:${this.isStaff ? 'staff' : 'customer'}`;
    },
  },
  methods: {
    async loadUserAgents({ silent = false } = {}) {
      try {
        const list = await DataService.getUserAgents();
        this.userAgents = Array.isArray(list) ? list : [];
      } catch (e) {
        this.userAgents = [];
        if (!silent) {
          this.$showErrorMessage(getApiErrorMessage(e, 'Failed to load user agents.'));
        }
      }
    },
  },
};
